import { render, staticRenderFns } from "./AvatarAdult2.vue?vue&type=template&id=0d17e2e1&scoped=true&lang=pug"
import script from "./AvatarAdult2.vue?vue&type=script&lang=js"
export * from "./AvatarAdult2.vue?vue&type=script&lang=js"
import style0 from "./AvatarAdult2.vue?vue&type=style&index=0&id=0d17e2e1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17e2e1",
  null
  
)

export default component.exports